/* eslint-disable */
import dayjs from "dayjs";
import _ from "lodash/fp";
import React from "react";
import DatePicker from "react-datepicker";
import { Controller } from "react-hook-form";
import advertisementDetailsLabel from "../../application_management/labels/advertisement_details_en.json";
import {
  AUTHOR_TYPES,
  BOOLEAN_OPTION,
} from "../../common/constants/dropdownOptions";
import {
  fullname,
  projectTitle,
  publicationJournalRegex,
  registrationNo
} from "../../common/constants/regex";
import { fromUTCDate, preventDateManualTyping, toUTCDate } from "../../helpers/Datetime";
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/qualification.css";
import { getYearList } from "../actions/profileAction";
import qualificationinformation from "../labels/qualification_information_en.json";
import qualificationinformation_hindi from "../labels/qualification_information_hin.json";
import numberformat from "../labels/serial_nos_en.json";
import QualificationTypeDropdown from "./QualificationTypeDropdown";
import useQualificationActions from "./useQualificationActions";
const PublicationsQualification = ({ setActiveQualificationIndex, setActiveIntershipIndex, setActivePublicationIndex, enableEditProfileWithLock, profileStatus}) => {
  const {
    handleQualificationChange,
    handleQualificationInfoSubmit,
    setActionType,
    register,
    handleSubmit,
    errors,
    qualificationState,
    onQualificationNameChange,
    currentEditQualificationIndex,
    publicationTypeList,
    nameOfIndexingBodiesList,
    getPublicationArticleTypeList,
    watch,
    control,
    setQualificationState,
  } = useQualificationActions();

  return (
    <form
      className="qualifcation_form"
      autoComplete="off"
      onSubmit={handleSubmit((e) => {
        handleQualificationInfoSubmit(e);
      })}
    >
      <div className="row">
        <QualificationTypeDropdown />
        <div className="col-md-4 mb-3 mt-3 responsive-input-public-name">
          <label className="float-start mb-0">
            {numberformat["4.2"]}&nbsp;
            {qualificationinformation.PUBLICATION_TYPE}
          </label>
          <span> {qualificationinformation_hindi.PUBLICATION_TYPE_hin} </span>
          <span className="redColor">*</span>{" "}
          <select
            className="form-select bg-color"
            value={qualificationState.publicationType}
            name="publicationType"
            ref={register({ required: true })}
            onInput={onQualificationNameChange}
          >
            <option key="" value="">
              {advertisementDetailsLabel.SELECT}
            </option>
            {publicationTypeList &&
              publicationTypeList.map((ele, i) => {
                return (
                  <option value={ele.id} key={i}>
                    {ele.name}
                  </option>
                );
              })}
          </select>
          {_.get("publicationType.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>

        <div className="col-md-4 mb-3 mt-3 responsive-input-public-index-name">
          <label className="float-start mb-0">
            {numberformat["4.3"]}&nbsp;
            {qualificationinformation.NAME_OF_INDEXING_BODIES}
          </label>
          <span className="redColor">*</span>{" "}
          <span>
            {" "}
            {qualificationinformation_hindi.NAME_OF_INDEXING_BODIES_hin}{" "}
          </span>
          <select
            className="form-select bg-color"
            value={qualificationState.indexingBodyLookupId}
            name="indexingBodyLookupId"
            ref={register({ required: true })}
            onInput={onQualificationNameChange}
          >
            <option key="" value="">
              {advertisementDetailsLabel.SELECT}
            </option>
            {nameOfIndexingBodiesList &&
              nameOfIndexingBodiesList.lookupOptionDtoList
                .sort((a, b) => {
                  return Number(a.sortOrder) - Number(b.sortOrder);
                })
                .map((ele, ind) => {
                  return (
                    <option key={ind++} value={ele.id}>
                      {ele.label}
                    </option>
                  );
                })}
          </select>
          {_.get("indexingBodyLookupId.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>

        <div className="col-md-4 mb-3 responsive-input-public-article-type">
          <label className="float-start mb-0">
            {numberformat["4.4"]}&nbsp;
            {qualificationinformation.TYPE_OF_ARTICLES}
          </label>
          <span> {qualificationinformation_hindi.TYPE_OF_ARTICLES_hin} </span>
          <span className="redColor">*</span>{" "}
          <select
            className="form-select bg-color"
            value={qualificationState.articleTypeLookupId}
            name="articleTypeLookupId"
            ref={register({ required: true })}
            onInput={onQualificationNameChange}
          >
            <option key="" value="">
              {advertisementDetailsLabel.SELECT}
            </option>
            {getPublicationArticleTypeList &&
              getPublicationArticleTypeList.lookupOptionDtoList
                .sort((a, b) => {
                  return Number(a.sortOrder) - Number(b.sortOrder);
                })
                .map((ele, ind) => {
                  return (
                    <option key={ind++} value={ele.id}>
                      {ele.label}
                    </option>
                  );
                })}
          </select>
          {_.get("articleTypeLookupId.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>

        <div className="col-md-4 mb-3 responsive-input-public-auth-name">
          <label className="float-start mb-0">
            {numberformat["4.5"]}&nbsp;{qualificationinformation.AUTHOR_NAME}
          </label>
          <span> {qualificationinformation_hindi.AUTHOR_NAME_hin} </span>
          <span className="redColor">*</span>{" "}
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            defaultValue={qualificationState.publicationAuthorName}
            maxLength={50}
            name="publicationAuthorName"
            ref={register({ required: true, pattern: fullname })}
            onInput={handleQualificationChange}

          />
          {_.get("publicationAuthorName.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
          {_.get("publicationAuthorName.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.Please_Enter_Text_Only}
            </p>
          )}
        </div>

        <div className="col-md-4 mb-3 responsive-input-public-first-auth">
          <label className="float-start mb-0">
            {numberformat["4.6"]}&nbsp;
            {qualificationinformation.FLG_FIRST_AUTHOR}
          </label>
          <span> {qualificationinformation_hindi.FLG_FIRST_AUTHOR_hin} </span>
          <span className="redColor">*</span>{" "}
          <select
            className="form-select bg-color"
            value={qualificationState.isPublicationFirstAuthor}
            name="isPublicationFirstAuthor"
            ref={register({ required: true })}
            onInput={handleQualificationChange}
          >
            <option value="">{advertisementDetailsLabel.SELECT}</option>
            {BOOLEAN_OPTION.map((ele, i) => {
              return (
                <option value={ele.value} key={i}>
                  {ele.label}
                </option>
              );
            })}
          </select>
          {_.get("isPublicationFirstAuthor.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>
        <div className="flex_publication col-md-12 ">
          <div className="col-md-4  mb-3 responsive-input-public-auth-type">
            <label className="float-start mb-0">
              {numberformat["4.7"]}&nbsp;{qualificationinformation.AUTHOR_TYPE}
            </label>
            <span> {qualificationinformation_hindi.AUTHOR_TYPE_hin} </span>
            <span className="redColor">*</span>{" "}
            <select
              className="form-select bg-color "
              value={qualificationState.publicationAuthorType}
              name="publicationAuthorType"
              ref={register({ required: true })}
              onInput={handleQualificationChange}
            >
              {AUTHOR_TYPES.map((ele, i) => {
                return (
                  <option value={ele.value} key={i}>
                    {ele.label}
                  </option>
                );
              })}
            </select>
            {_.get("publicationAuthorType.type", errors) === "required" && (
              <p className="errorText">
                {qualificationinformation.MANDATORY_FIELD_MESSAGE}
              </p>
            )}
          </div>
          <div className="form-group col-md-8 responsive-input-public-jour-details">
            <div className="">
              <label
                className="float-start mb-0"
                for="publicationJournalDetails"
              >
                {numberformat["4.8"]}&nbsp;
                {qualificationinformation.JOURNAL_DETAILS}
              </label>
              <span>
                {" "}
                {qualificationinformation_hindi.JOURNAL_DETAILS_hin}{" "}
                <span className="redColor">*</span>{" "}
                <div className="tooltip-wrapper">
                  <span className="showAllowedCharacter text-warning"> ! </span>
                  <span className="tooltip-text">
                    {qualificationinformation.PUBLICATION_NAME_OF_JOURNAL_TITLE_VALIDATION_NOTE}
                  </span>
                </div>

              </span>
              <textarea
                id="publicationJournalDetails"
                className="form-control bg-color text-uppercase"
                maxLength={350}
                defaultValue={qualificationState.publicationJournalDetails}
                name="publicationJournalDetails"
                ref={register({ required: true, pattern: publicationJournalRegex })}
                onInput={handleQualificationChange}
              />
              {/* <span className="text-primary">
                {qualificationinformation.PUBLICATION_NAME_OF_JOURNAL_TITLE_VALIDATION_NOTE}
              </span> */}
              {_.get("publicationJournalDetails.type", errors) ===
                "required" && (
                  <p className="errorText">
                    {qualificationinformation.MANDATORY_FIELD_MESSAGE}
                  </p>
                )}
              {_.get("publicationJournalDetails.type", errors) ===
                "pattern" && (
                  <p className="errorText">
                    {qualificationinformation.PUBLICATION_JOURNAL_SPECIAL_VALIDATION_MESSAGE}
                  </p>
                )}

              {/* {_.get("publicationJournalDetails.type", errors) === "pattern" && (
               <p className="errorText">{qualificationinformation.ONLY_CHARATERS_NUMBERS}</p>
                 )} */}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 mb-3 mt-3 responsive-input-public-public-year">
          <label className="float-start mb-0">
            {numberformat["4.9"]}&nbsp;
            {qualificationinformation.PUBLICATION_YEAR}{" "}
          </label>
          <span> {qualificationinformation_hindi.PUBLICATION_YEAR_hin} </span>
          <span className="redColor">*</span>{" "}

          <select
            className="form-select  bg-color"
            name="publicationYear"
            maxLength={4}
            id="sq"
            ref={register({ required: true })}
            value={qualificationState.publicationYear}
            defaultValue={
              qualificationState &&
              qualificationState.publicationYear
            }
            onInput={handleQualificationChange}
          >
            <option key={0} value="">
              {"Select Year"}
            </option>
            {getYearList()}
          </select>
          {_.get("publicationYear.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
          {_.get("publicationYear.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.Please_Enter_Only_Number}
            </p>
          )}
        </div>
        <div className="col-md-4 mb-3 mt-3 responsive-input-public-index-2">
          <label className="float-start mb-0">
            {numberformat["4.10"]}&nbsp;
            {qualificationinformation.FLG_IMPACT_INDEX_2_0}
            <span>
              {" "}
              {qualificationinformation_hindi.FLG_IMPACT_INDEX_2_0_hin}{" "}
            </span>
            <span className="redColor">*</span>{" "}
          </label>
          <select
            className="form-select bg-color"
            value={qualificationState.isImpactIndex20OrMore}
            name="isImpactIndex20OrMore"
            ref={register({ required: true })}
            onInput={handleQualificationChange}
          >
            <option value="">{advertisementDetailsLabel.SELECT}</option>
            {BOOLEAN_OPTION.map((ele, i) => {
              return (
                <option value={ele.value} key={i}>
                  {ele.label}
                </option>
              );
            })}
          </select>
          {_.get("isImpactIndex20OrMore.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>
        <div className="col-md-4 mb-3 mt-3 responsive-input-public-accep-date">
          <label className="float-start mb-0">
            {numberformat["4.11"]}&nbsp;{" "}
            {qualificationinformation.PUBLICATION_ACCEPTANCE_DATE}
            <span>
              {" "}
              {
                qualificationinformation_hindi.PUBLICATION_ACCEPTANCE_DATE_hin
              }{" "}
            </span>
            <span className="redColor">*</span>{" "}
          </label>
          <Controller
            name="publicationAcceptanceDate"
            key={
              qualificationState.publicationAcceptanceDate
                ? "publicationAcceptanceDate"
                : "publicationAcceptanceDate1"
            }
            defaultValue={
              qualificationState.publicationAcceptanceDate
                ? dayjs(qualificationState.publicationAcceptanceDate).toDate()
                : ""
            }
            rules={{ required: true }}
            control={control}
            render={({ onChange, value }) => (
              <DatePicker
                showIcon
                selected={
                  qualificationState.publicationAcceptanceDate
                    ? dayjs(qualificationState.publicationAcceptanceDate).toDate()
                    : fromUTCDate(value)
                }
                maxDate={new Date()}
                onChange={(e) => {
                  setQualificationState({
                    ...qualificationState,
                    publicationAcceptanceDate: toUTCDate(e),
                  });
                  onChange(toUTCDate(e));
                }}
                onKeyDown={preventDateManualTyping}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText={commonLabels.DATE_FORMAT}
                dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                className="form-control bg-color"
                icon={
                  <img
                    src="/icons/calender.png"
                    className="date-picker-icon"
                    alt="date-icon"
                  ></img>
                }
              />

            )}
          />
          {_.get("publicationAcceptanceDate.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>
        <div className="col-md-4 mb-3 mt-3 responsive-input-public-published-date">
          <label className="float-start mb-0">
            {numberformat["4.12"]}&nbsp;{" "}
            {qualificationinformation.PUBLICATION_PUBLISHED_DATE}
          </label>
          <span className="redColor">*</span>
          <Controller
            name="publicationPublishedDate"
            key={
              qualificationState.publicationPublishedDate
                ? "publicationPublishedDate"
                : "publicationPublishedDate1"
            }
            control={control}
            rules={{ required: true }}
            defaultValue={
              qualificationState.publicationPublishedDate
                ? dayjs(qualificationState.publicationPublishedDate).toDate()
                : ""
            }
            render={({ onChange, value }) => (
              <DatePicker
                showIcon
                selected={
                  qualificationState.publicationPublishedDate
                    ? dayjs(
                      qualificationState.publicationPublishedDate
                    ).toDate()
                    : fromUTCDate(value)
                }
                onChange={(e) => {
                  setQualificationState({
                    ...qualificationState,
                    publicationPublishedDate: toUTCDate(e),
                  });
                  onChange(toUTCDate(e));
                }}
                onKeyDown={preventDateManualTyping}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText={commonLabels.DATE_FORMAT}
                dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                className="form-control bg-color"
                maxDate={new Date()}
                icon={
                  <img
                    src="/icons/calender.png"
                    className="date-picker-icon"
                    alt="date-icon"
                  ></img>
                }
              />
            )}
          />
          {_.get("publicationPublishedDate.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>
        <div className="col-md-4 mb-3 mt-3 responsive-input-public-issn">
          <label className="float-start mb-0">
            {numberformat["4.13"]}&nbsp;{qualificationinformation.ISSN_NUmber}
          </label>
          <span> {qualificationinformation_hindi.ISSN_NUMBER_HIN} </span>
          <span className="redColor">*</span>{" "}
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            defaultValue={qualificationState.publicationIssnNo}
            maxLength={50}
            name="publicationIssnNo"
            ref={register({ required: true, pattern: registrationNo })}
            onInput={handleQualificationChange}

          />
          {_.get("publicationIssnNo.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
          {_.get("publicationIssnNo.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.Please_Enter_Text_Only}
            </p>
          )}
        </div>
        <div className="col-md-4 mb-3 responsive-input-public-index-2">
          <label className="float-start mb-0">
            {numberformat["4.14"]}&nbsp;
            {qualificationinformation.HOD_GUIDE_INCHARGE}
            <span>
              {" "}
              {qualificationinformation_hindi.HOD_GUIDE_INCHARGE_hin}{" "}
            </span>
            <span className="redColor">*</span>{" "}
          </label>
          <select
            className="form-select bg-color"
            value={qualificationState.isPublicationGuide}
            name="isPublicationGuide"
            ref={register({ required: true })}
            onInput={handleQualificationChange}
          >
            <option value="">{advertisementDetailsLabel.SELECT}</option>
            {BOOLEAN_OPTION.map((ele, i) => {
              return (
                <option value={ele.value} key={i}>
                  {ele.label}
                </option>
              );
            })}
          </select>
          {_.get("isPublicationGuide.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
        </div>
      </div>

      <div className="row">

        <div className="col-md-12 mb-3 responsive-input-public-paper-title">
          <label className="float-start mb-0">
            {numberformat["4.15"]}&nbsp;{qualificationinformation.PAPER_TITLE}
          </label>
          <span className="redColor">*</span>
          <input
            type="text"
            id="publicationPaperTitle"
            maxLength={200}
            className="form-control bg-color text-uppercase"
            defaultValue={qualificationState.publicationPaperTitle}
            name="publicationPaperTitle"
            ref={register({ required: true, pattern: projectTitle })}
            onInput={handleQualificationChange}
          />
          {_.get("publicationPaperTitle.type", errors) === "required" && (
            <p className="errorText">
              {qualificationinformation.MANDATORY_FIELD_MESSAGE}
            </p>
          )}
          {_.get("publicationPaperTitle.type", errors) === "pattern" && (
            <p className="errorText">
              {qualificationinformation.INVALID_INPUT}
            </p>
          )}
          <span className="text-primary">
            {qualificationinformation.PROJ_TITLE_VALIDATION_NOTE}
          </span>
        </div>
      </div>

      <div className="text-center mb-5 mt-5">
        {
          profileStatus !== true ? (
            <>
              {currentEditQualificationIndex !== -1 ? (
                <button
                  type="submit"
                  name="edit"
                  className=" btn btn-primary custom_button  m-1"
                  onClick={() => {
                    setActionType("edit");
                    setActiveQualificationIndex("");
                    setActiveIntershipIndex("");
                    setActivePublicationIndex("");
                  }}
                >
                  {qualificationinformation.UPDATE}
                </button>
              ) : (
                <button
                  type="submit"
                  name="add"
                  className=" btn btn-primary custom_button  m-1"
                  onClick={() => {
                    setActionType("add");
                  }}
                >
                  {qualificationinformation.ADD}
                </button>
              )}
            </>
          ) : (
            enableEditProfileWithLock?.editProfileWithLock == "1" ? (
              (() => {
                const qualificationInfoList = enableEditProfileWithLock?.QualificationInfo?.split(",") || [];
                const canCreate = qualificationInfoList.includes("C");
                const canUpdate = qualificationInfoList.includes("U");

                if (currentEditQualificationIndex !== -1 && canUpdate) {
                  return (
                    <button
                      type="submit"
                      name="edit"
                      className=" btn btn-primary custom_button  m-1"
                      onClick={() => {
                        setActionType("edit");
                        setActiveQualificationIndex("");
                        setActiveIntershipIndex("");
                        setActivePublicationIndex("");
                      }}
                    >
                      {qualificationinformation.UPDATE}
                    </button>
                  );
                } else if (canCreate) {
                  return (
                    <button
                      type="submit"
                      name="add"
                      className=" btn btn-primary custom_button  m-1"
                      onClick={() => {
                        setActionType("add");
                      }}
                    >
                      {qualificationinformation.ADD}
                    </button>
                  );
                }

              })()
            ) : ""
          )
        }
      </div>
    </form>
  );
};
export default PublicationsQualification;
